import { initialiseInstanceComponents } from "../../shared/instanceComponentInitialiser";
import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { ZoomableGallery } from "./zoomableGallery";

export function initialiseZoomableGallery() {
    initialiseInstanceComponents<ZoomableGallery>(ZoomableGallery, HelperUtils.addDataAttributeTags(AttributeEnums.ZoomableGallery.ZoomableGallery), zoomableGalleryFactory);
}

function zoomableGalleryFactory(currentElement: Element): void {
    let newZoomableGallery = new ZoomableGallery(currentElement);
    (<any>window)[currentElement.getAttribute(AttributeEnums.ZoomableGallery.ZoomableGallery) + 'ZoomableGallery'] = newZoomableGallery;
}